module.exports = __webpack_public_path__ + "media/images/p-about/can/investment-289c5387723e4039d394f1c51904dfb2.svg";